<template>
  <div class="app-container">
    <PageHeader title="供应商付款申请" icon="el-icon-money" />
    
    <!-- 搜索栏 -->
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="订单名称">
          <el-input v-model="searchForm.orderName" placeholder="请输入订单名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="草稿" :value="1"></el-option>
            <el-option label="待审核" :value="2"></el-option>
            <el-option label="审核中" :value="3"></el-option>
            <el-option label="审核通过" :value="4"></el-option>
            <el-option label="拒绝" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 主数据表格 -->
    <el-card class="table-card">
      <el-table 
        v-loading="listLoading" 
        :data="paymentList" 
        border 
        fit 
        highlight-current-row>
        <el-table-column label="订单名称" prop="order_name" align="center" />
        <el-table-column label="申请金额" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.payment_amount) }}
          </template>
        </el-table-column>
        <el-table-column label="收款人" prop="supplier_name" align="center" />
        <el-table-column label="收款账号" prop="supplier_bank_account" align="center" />
        <el-table-column label="收款银行" prop="supplier_bank_name" align="center" />
        <el-table-column label="状态" align="center">
          <template slot-scope="{row}">
            <el-tag :type="getStatusType(row.status)">{{ getStatusText(row.status) }}</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="工作流" align="center" width="120">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.process_id"
             :type="getTimelineNodeType(row.workflowStatus)"
              size="mini"
              @click="handleViewFlow(scope.row)"
            >
              查看流程
            </el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>  -->

        <el-table-column label="工作流" align="center">
          <template slot-scope="{row}">
            <el-tag 
              size="medium" 
              :type="getTimelineNodeType(row.workflowStatus)" 
              style="cursor: pointer"
              @click="handleShowFlow(row)">
              {{ row.workflow?.workFlowName || '暂无工作流' }}
              <i class="el-icon-arrow-right el-icon--right"></i>
            </el-tag>
          </template>
        
          <!-- <template slot-scope="{row}">
          <el-tag size="medium" :type="row.status === 1 ? 'success' : 'info'" style="cursor: pointer"
            @click="handleShowFlow(row)">
            {{ row.workFlowName }}
            <i class="el-icon-arrow-right el-icon--right"></i>
          </el-tag>
        </template> -->
     





        </el-table-column>

<el-table-column label="申请时间" prop="apply_time" align="center">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.apply_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-dropdown @command="(command) => handleCommand(command, scope.row)" trigger="click">
              <el-button type="primary" size="mini">
                操作 <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <!-- 草稿状态：编辑、提交、删除 -->
                <template v-if="scope.row.status === 1">
                  <el-dropdown-item command="edit">
                    <i class="el-icon-edit"></i>编辑
                  </el-dropdown-item>
                  <el-dropdown-item command="submit">
                    <i class="el-icon-check"></i>提交审核
                  </el-dropdown-item>
                  <el-dropdown-item command="delete" divided>
                    <i class="el-icon-delete"></i>删除
                  </el-dropdown-item>
                </template>

                <!-- 待审核状态：查看、审核、取消 -->
                <template v-else-if="scope.row.status === 2">
                  <el-dropdown-item command="detail">
                    <i class="el-icon-document"></i>查看
                  </el-dropdown-item>
                  <el-dropdown-item command="approve">
                    <i class="el-icon-check"></i>审核
                  </el-dropdown-item>
                  <el-dropdown-item command="cancel" divided>
                    <i class="el-icon-close"></i>取消
                  </el-dropdown-item>
                </template>

                <!-- 审核中状态：只能查看 -->
                <template v-else-if="scope.row.status === 3">
                  <el-dropdown-item command="detail">
                    <i class="el-icon-document"></i>查看
                  </el-dropdown-item>
                </template>

                <!-- 审核通过状态：查看、取消 -->
                <template v-else-if="scope.row.status === 4">
                  <el-dropdown-item command="detail">
                    <i class="el-icon-document"></i>查看
                  </el-dropdown-item>
                  <el-dropdown-item command="voucher">
                    <i class="el-icon-tickets"></i>付款凭证
                  </el-dropdown-item>
                  <el-dropdown-item command="cancel" divided>
                    <i class="el-icon-close"></i>取消
                  </el-dropdown-item>
                </template>

                <!-- 拒绝状态：编辑、重新提交、删除 -->
                <template v-else-if="scope.row.status === 5">
                  <el-dropdown-item command="edit">
                    <i class="el-icon-edit"></i>编辑
                  </el-dropdown-item>
                  <el-dropdown-item command="resubmit">
                    <i class="el-icon-refresh"></i>重新提交
                  </el-dropdown-item>
                  <el-dropdown-item command="delete" divided>
                    <i class="el-icon-delete"></i>删除
                  </el-dropdown-item>
                </template>

                <!-- 其他状态：只显示查看 -->
                <template v-else>
                  <el-dropdown-item command="detail">
                    <i class="el-icon-document"></i>查看
                  </el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 添加审核对话框 -->
    <el-dialog
      title="付款申请审核"
      :visible.sync="approveDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form ref="approveForm" :model="approveForm" :rules="approveRules" label-width="80px">
        <!-- <el-form-item label="审核结果" prop="approved">
          <el-radio-group v-model="approveForm.approved">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">拒绝</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="审核意见" prop="comment">
          <el-input
            
            v-model="approveForm.comment"
            :rows="4"
            placeholder="请输入审核意见"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitPayment(1)">驳回</el-button>
        <el-button type="primary" @click="submitPayment(2)" :loading="approveLoading">通过</el-button>
      </div>
    </el-dialog>

    <!-- 修改工作流对话框 -->
    <!-- <el-dialog title="审批流程" :visible.sync="flowDialogVisible" width="700px" class="flow-dialog">">
      <div v-loading="flowLoading" class="flow-container">
        <div class="flow-steps">
          <div v-for="(node, index) in flowList" 
               :key="index" 
               class="flow-step"
               :class="{ 'is-completed': node.status === 1 }"> -->
            <!-- 步骤标题 -->
            <!-- <div class="step-header">
              <div class="step-number">{{ index + 1 }}</div>
              <div class="step-title">{{ node.nodeName }}</div>
              <el-tag size="mini" :type="getStatusType(node.status)">
                {{ node.status === 1 ? '已完成' : '处理中' }}
              </el-tag>
            </div> -->

            <!-- 审批人列表 -->
            <!-- <div class="step-content">
              <div v-for="approver in node.approvers" 
                   :key="approver.approverId" 
                   class="approver-item">
                <div class="approver-info">
                  <span class="approver-name">{{ approver.approverName }}</span>
                  <el-tag size="mini" :type="getApproverStatusType(approver.status)">
                    {{ getApproverStatusText(approver.status) }}
                  </el-tag>
                </div>
                <div class="approve-time" v-if="approver.approveTime">
                  {{ formatDateTime(approver.approveTime) }}
                </div>
                <div v-if="approver.remark" class="approve-comment">
                  审核意见：{{ approver.remark }}
                </div>
              </div>
            </div> -->

            <!-- 连接线 -->
            <!-- <div class="step-line" v-if="index !== flowList.length - 1">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </el-dialog> -->

 <!-- 审批流程对话框 -->
 <el-dialog title="审批流程" :visible.sync="flowDialogVisible" width="700px" class="flow-dialog">
      <div v-loading="flowLoading">
        <el-timeline>
          <el-timeline-item v-for="(flow, index) in flowList" :key="index" :type="getTimelineNodeType(flow.status)"
            size="large">
            <div class="flow-item">
              <!-- 节点标题和状态 -->
              <div class="flow-header">
                <span class="flow-title">
                  <span class="step-tag">步骤 {{ flow.step }}</span>
                  {{ flow.title }}
                </span>
                <el-tag size="mini" :type="getStatusTagType(flow.status)">
                  {{ flow.statusText }}
                </el-tag>
              </div>

              <!-- 审批人信息 -->
              <div class="flow-content">
                <div class="flow-info">
                  <div class="info-header">
                    <i class="el-icon-user"></i>
                    <span>审批人</span>
                  </div>
                  <div class="approver-list">
                    <template v-if="flow.approverDetails && flow.approverDetails.length">
                      <div v-for="(approver, idx) in flow.approverDetails" :key="idx" class="approver-item">
                        <div class="approver-info">
                          <!-- 审批人名字和状态 -->
                          <div class="approver-row">
                            <span class="approver-name">{{ approver.name }}</span>
                            <el-tag size="mini" :type="getStatusTagType(approver.status)">
                              {{ getApproverStatusText(approver.status) }}
                            </el-tag>
                            <span class="approve-time">
                              {{ approver.time ? formatDateTime(approver.time) : '' }}
                            </span>
                          </div>
                          <!-- 审核意见直接跟在审批人下方 -->
                          <div v-if="approver.comment" class="approve-comment">
                            审核意见：{{ approver.comment }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <span v-else class="no-approver">待处理</span>
                  </div>
                </div>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>


    <!-- 添加付款凭证对话框 -->
    <el-dialog
      title="付款凭证"
      :visible.sync="voucherDialogVisible"
      width="900px"
      :close-on-click-modal="false"
    >
      <el-form ref="voucherForm" :model="voucherForm" :rules="voucherRules" label-width="100px">
        <el-row :gutter="20">
          <!-- 左侧付款信息 -->
          <el-col :span="12">
            <div class="form-section-title">付款信息</div>
            <el-form-item label="申请金额">
              <el-input :value="formatAmount(voucherForm.apply_amount)" disabled />
            </el-form-item>
            
            <el-form-item label="付款类型" prop="payment_type">
              <el-select v-model="voucherForm.payment_type" placeholder="请选择付款类型" style="width: 100%">
                <el-option
                  v-for="item in paymentTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            
            <el-form-item label="付款金额" prop="payment_amount">
              <el-input-number 
                v-model="voucherForm.payment_amount"
                :precision="2"
                :min="0"
                controls-position="right"
                style="width: 100%"
              />
            </el-form-item>
            
            <el-form-item label="付款时间" prop="payment_time">
              <el-date-picker
                v-model="voucherForm.payment_time"
                type="datetime"
                placeholder="选择付款时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
              />
            </el-form-item>
            
            <el-form-item label="付款凭证" prop="payment_image">
              <el-upload
                class="upload-container"
                action="/api/api/v1/upload/file"
                :headers="uploadHeaders"
                :on-success="handleUploadSuccess"
                :on-error="handleUploadError"
                :before-upload="beforeUpload"
                :on-exceed="handleExceed"
                :limit="1"
                :file-list="voucherForm.fileList"
                name="file"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2MB</div>
              </el-upload>
            </el-form-item>
            
            <el-form-item label="付款人" prop="payment_person">
              <el-input v-model="voucherForm.payment_person" placeholder="请输入付款人" />
            </el-form-item>
            
            <el-form-item label="付款渠道" prop="pay_channel">
              <el-select v-model="voucherForm.pay_channel" placeholder="请选择付款渠道" style="width: 100%" @change="getPayAccountDict">
                <el-option
                  v-for="item in payChannelOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            
            <el-form-item label="付款账号" prop="pay_account">
              <el-select v-model="voucherForm.pay_account" placeholder="请选择付款账号" style="width: 100%">
                <el-option
                  v-for="item in payAccountOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            
            <el-form-item label="付款备注" prop="pay_remark">
              <el-input
                type="textarea"
                v-model="voucherForm.pay_remark"
                placeholder="请输入付款备注"
              />
            </el-form-item>
          </el-col>

          <!-- 右侧收款信息 -->
          <el-col :span="12">
            <div class="form-section-title">收款信息</div>
            <el-form-item label="收款方式" prop="receiver_method">
              <el-select v-model="voucherForm.receiver_method" placeholder="请选择收款方式" style="width: 100%">
                <el-option
                  v-for="item in paymentTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            
            <el-form-item label="收款渠道" prop="receiver_channel">
              <el-select v-model="voucherForm.receiver_channel" placeholder="请选择收款渠道" style="width: 100%">
                <el-option
                  v-for="item in paymentChannelOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            
            <el-form-item label="收款人" prop="receiver_name">
              <el-input v-model="voucherForm.receiver_name" placeholder="请输入收款人" />
            </el-form-item>
            
            <el-form-item label="收款银行" prop="receiver_bank">
              <el-input v-model="voucherForm.receiver_bank" placeholder="请输入收款银行" />
            </el-form-item>
            
            <el-form-item label="收款账号" prop="receiver_account">
              <el-input v-model="voucherForm.receiver_account" placeholder="请输入收款账号" />
            </el-form-item>
            
            <el-form-item label="银行行号" prop="receiver_bank_code">
              <el-input v-model="voucherForm.receiver_bank_code" placeholder="请输入银行行号" />
            </el-form-item>
            
            <el-form-item label="收款备注" prop="receiver_remark">
              <el-input
                type="textarea"
                v-model="voucherForm.receiver_remark"
                placeholder="请输入收款备注"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="voucherDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitVoucher" :loading="voucherSubmitting">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '@/components/common/PageHeader.vue'
import request from '@/utils/request'

export default {
  name: 'PaymentList',
  components: {
    PageHeader
  },
  beforeCreate() {
    console.log('PaymentList beforeCreate')
  },
  created() {
    console.log('PaymentList created')
    this.fetchData().catch(error => {
      console.error('初始化数据失败:', error)
      this.$message.error('页面加载失败')
    })
    
    // 添加数据监听
    this.$watch('paymentList', (newVal) => {
      console.log('paymentList 数据变化:', newVal)
    }, { deep: true })

    // 获取收款方式字典
    this.getPaymentMethodDict()
    this.getPaymentChannelDict()
    this.getPaymentTypeDict()
    this.getPayChannelDict()
    this.getPayAccountDict()

    // 立即加载所有字典数据
    Promise.all([
      this.getPaymentMethodDict(),
      this.getPaymentChannelDict(),
      this.getPaymentTypeDict(),
      this.getPayChannelDict(),
      this.getPayAccountDict()
    ]).catch(error => {
      console.error('加载字典数据失败:', error)
      this.$message.error('加载字典数据失败')
    })
  },
  mounted() {
    console.log('PaymentList mounted')
  },
  data() {
    return {
      searchForm: {
        orderName: '',
        status: ''
      },
      paymentList: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      listLoading: false,
      approveDialogVisible: false,
      approveForm: {
        id: '',
        approved: 1,
        comment: ''
      },
      channels:[],
      approveRules: {
        approved: [
          { required: true, message: '请选择审核结果', trigger: 'change' }
        ],
        comment: [
          { required: true, message: '请输入审核意见', trigger: 'blur' },
          { min: 2, max: 200, message: '长度在 2 到 200 个字符', trigger: 'blur' }
        ]
      },
      approveLoading: false,
      flowDialogVisible: false,
      flowLoading: false,
      flowList: [],
      currentProcessName: '',
      voucherDialogVisible: false,
      voucherForm: {
        id: '',
        application_id: '',
        apply_amount: 0,
        payment_type: '',
        payment_amount: 0,
        payment_time: '',
        payment_image: '11111',
        payment_person: '',
        pay_channel: '',
        pay_account: '',
        pay_remark: '',
        receiver_method: '',
        receiver_channel: '',
        receiver_name: '',
        receiver_account: '',
        receiver_bank: '',
        receiver_bank_code: '',
        receiver_remark: ''
      },
      voucherRules: {
        payment_type: [{ required: true, message: '请选择付款类型', trigger: 'change' }],
        payment_amount: [{ required: true, message: '请输入付款金额', trigger: 'blur' }],
        payment_time: [{ required: true, message: '请选择付款时间', trigger: 'change' }],
        payment_person: [{ required: true, message: '请输入付款人', trigger: 'blur' }],
        pay_channel: [{ required: true, message: '请选择付款渠道', trigger: 'change' }],
        pay_account: [{ required: true, message: '请输入付款账号', trigger: 'blur' }],
        receiver_method: [{ required: true, message: '请选择收款方式', trigger: 'change' }],
        receiver_name: [{ required: true, message: '请输入收款人', trigger: 'blur' }],
        receiver_bank: [{ required: true, message: '请输入收款银行', trigger: 'blur' }],
        receiver_account: [{ required: true, message: '请输入收款账号', trigger: 'blur' }]
      },
      voucherSubmitting: false,
      // 收款方式字典
      paymentMethodOptions: [],
      // 收款渠道选项
      paymentChannelOptions: [],
      // 付款类型选项
      paymentTypeList: [],
      // 付款渠道选项
      payChannelOptions: [],
      // 付款账号选项
      payAccountOptions: [],
      uploadHeaders: {
        Authorization: 'Bearer ' + this.$store.getters.token
      },
      fileList: [],
    }
  },
  methods: {
    handlePreview(file) {
      if (file.url) {
        window.open(file.url)
      }
    },
    handleRemove(file, fileList) {
      this.voucherForm.fileList = fileList
      this.voucherForm.payment_image = '' // 清空付款凭证路径
    },
    async fetchData() {
      this.listLoading = true
      try {
        console.log('开始获取数据...')
        const res = await request({
          url: '/api/v1/purchasing-order/payment/list',
          method: 'post',
          data: {
            page: this.page.current,
            size: this.page.size,
            status: this.searchForm.status || -1
          }
        })
        
        // 添加详细的数据日志
        console.log('API返回的完整数据:', res)
        console.log('单条数据示例:', res.data?.[0])
        
        if (res.status === 1) {
          this.paymentList = Array.isArray(res.data) ? res.data : []
          this.paymentList = this.paymentList.map(item => {
            const processedItem = {
              ...item,
              workFlowName: item.workFlowName || item.workflow_name || '暂无流程',
              workflowStatus: item.status || 0
            }
            console.log('处理后的单条数据:', processedItem)
            return processedItem
          })
          
          this.page.total = res.total || 0
        } else {
          this.$message.error(res.msg || '获取数据失败')
        }
      } catch (error) {
        console.error('获取付款申请列表失败:', error)
        this.$message.error('获取付款申请列表失败')
      } finally {
        this.listLoading = false
      }
    },
    formatAmount(amount) {
      return `¥${Number(amount).toFixed(2)}`
    },
    formatDateTime(date) {
      if (!date) return '-'
      const d = new Date(date)
      if (isNaN(d.getTime())) return '-'
      
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')
      const second = String(d.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },
    getStatusType(status) {
      const statusMap = {
        1: 'info',     // 草稿
        2: 'warning',  // 待审核
        3: 'primary',  // 审核中
        4: 'success',  // 已通过
        5: 'danger',    // 已拒绝
        6:'info',      // 待付款
        7:'success'    // 已付款
      }
      return statusMap[status] || 'info'
     
    },
    getStatusText(status) {
      const statusMap = {
        1: '草稿',
        2: '待审核',
        3: '审核中',
        4: '已通过',
        5: '已拒绝',
        6:'待付款',
        7:'已付款'
      }
      return statusMap[status] || '未知状态'
    },
    handleCommand(command, row) {
      switch (command) {
        case 'edit':
          this.handleEdit(row)
          break
        case 'submit':
        case 'resubmit':
          this.handleSubmit(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
        case 'detail':
          this.handleDetail(row)
          break
        case 'approve':
          this.handleApprove(row)
          break
        case 'cancel':
          this.handleCancel(row)
          break
        case 'voucher':
          this.handleVoucher(row)
          break
      }
    },
    handleEdit(row) {
      console.log('编辑:', row)
      // TODO: 实现编辑功能
    },
    async handleSubmit(row) {
      try {
        //新增二次确认，点确定后调用接口
        await this.$confirm('确定要提交该付款申请吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        })
        const res = await request({
          url: '/api/v1/purchasing-order/payment/submit',
          method: 'post',
          data: {
            id: row.id
          }
        })

        if (res.status === 1) {
          this.$message.success('提交成功')
          this.fetchData()
        } else {
          this.$message.error(res.msg || '提交失败')
        }
      } catch (error) {
        console.error('提交失败:', error)
        this.$message.error('提交失败，请重试')
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除该付款申请吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const res = await request({
          url: '/api/v1/purchasing-order/payment/delete',
          method: 'post',
          data: {
            id: row.id
          }
        })

        if (res.status === 1) {
          this.$message.success('删除成功')
          this.fetchData()
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error)
          this.$message.error('删除失败，请重试')
        }
      }
    },
    async handleCancel(row) {
      try {
        await this.$confirm('确定要取消该付款申请吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const res = await request({
          url: '/api/v1/purchasing-order/payment/cancel',
          method: 'post',
          data: {
            id: row.id
          }
        })

        if (res.status === 1) {
          this.$message.success('取消成功')
          this.fetchData()
        } else {
          this.$message.error(res.msg || '取消失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('取消失败:', error)
          this.$message.error('取消失败，请重试')
        }
      }
    },
    handleDetail(row) {
      console.log('查看明细:', row)
    },
    handleApprove(row) {
      this.approveForm = {
        id: row.id,
        comment: ''
      }
      this.approveDialogVisible = true
    },
    handleSearch() {
      this.page.current = 1
      this.fetchData()
    },
    resetSearch() {
      this.searchForm = {
        orderName: '',
        status: ''
      }
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.fetchData()
    },
    async submitPayment(type) {
      try {
        await this.$refs.approveForm.validate()
        this.approveLoading = true
        const res = await request({
          url: '/api/v1/purchasing-order/payment/approve',
          method: 'post',
          data: {
            id: this.approveForm.id,
            approved: type,
            comment: this.approveForm.comment
          }
        })

        if (res.status === 1) {
          this.$message.success('审核成功')
          this.approveDialogVisible = false
          this.fetchData() // 刷新列表
        } else {
          this.$message.error(res.msg || '审核失败')
        }
      } catch (error) {
        console.error('审核失败:', error)
        this.$message.error('审核失败，请重试')
      } finally {
        this.approveLoading = false
      }
    },
    async handleShowFlow(row) {
      this.flowLoading = true
      this.flowDialogVisible = true
      try {
        const workflow = row.workflow || { nodes: [] }
        
        if (workflow.nodes && workflow.nodes.length > 0) {
          this.flowList = workflow.nodes.map(node => {
            const approverDetails = (node.approvers || []).map(approver => ({
              name: approver.approver || '未知审批人',
              status: Number(approver.status || 0),
              time: approver.createdAt || approver.approverTime || null,
              comment: approver.approverRemark || approver.remark || ''
            }))

            return {
              title: `${node.nodeName || '未知节点'} ${this.getNodeTypeText(node.nodeType)}`,
              step: node.step || 1,
              status: node.status || 0,
              statusText: this.getNodeStatusText(node.status),
              nodeType: node.nodeType,
              isActive: node.status === 1,
              isCompleted: node.status === 2,
              approverDetails: approverDetails
            }
          })
        } else {
          this.flowList = [{
            title: '暂无流程数据',
            step: 1,
            status: 0,
            statusText: '未开始',
            approverDetails: []
          }]
        }

        console.log('处理后的流程数据:', this.flowList)
      }catch (error) {
        console.error('处理流程数据失败:', error)
        this.$message.error('处理流程数据失败')
        this.flowList = []
      } finally {
        this.flowLoading = false
      }
    },
    getNodeTypeText(nodeType) {
      const typeMap = {
        0: '',           // 默认类型
        1: '(串行审批)', // 串行审批
        2: '(并行与)',   // 并行且签
        3: '(并行或)'    // 并行或签
      }
      return typeMap[nodeType] || ''
    },
    // 获取时间线节点类型
    getTimelineNodeType(status) {
      switch (status) {
        case 2: return 'success'  // 已完成
        case 1: return 'primary'  // 进行中
        case 0: return 'info'     // 未开始
        case 3: return 'danger'   // 已拒绝
        case 4: return 'warning'  // 已取消
        default: return 'info'
      }
    },
    
    getNodeStatusText(status) {
      const statusMap = {
        0: '未开始',
        1: '进行中',
        2: '已完成',
        3: '已拒绝',
        4: '已取消',
        5: '已终止'
      }
      return statusMap[status] || '未知状态'
    },
   
    
     // 获取审批人状态文本
     getApproverStatusText(status) {
      const statusMap = {
        0: '未处理',
        1: '处理中',
        2: '已拒绝',
        3: '已通过',
        4: '已转交',
        5: '已回退',
        6: '已终止'
      }
      return statusMap[status] || '未知状态'
    },
 

   // 获取状态标签类型
    getStatusTagType(status) {
      const typeMap = {
        0: 'info',    // 未处理
        1: 'warning', // 处理中
        2: 'danger',  // 已拒绝
        3: 'success', // 已通过
        4: 'info',    // 已转交
        5: 'warning', // 已回退
        6: 'danger'   // 已终止
      }
      console.log('状态标签类型:', typeMap[status])
      return typeMap[status] || 'info'
    },
     // 获取时间轴项的颜色
     getTimelineItemColor(status) {
      return status === 3 ? '#67C23A' : status === 1 ? '#E6A23C' : '#409EFF'
    },
    
    handleVoucher(row) {
      this.voucherForm = {
        id: '',
        application_id: row.id,
        apply_amount: row.payment_amount,
        payment_type: '',
        payment_amount: row.payment_amount || 0,
        payment_time: new Date().toISOString().slice(0, 19).replace('T', ' '),
        payment_image: '11111',
        payment_person: '',
        pay_channel: '',
        pay_account: '',
        pay_remark: '',
        receiver_method: row.supplier_pay_method  || '',
        receiver_channel: row.supplier_pay_channel || '',
        receiver_name: row.supplier_name || '',
        receiver_account: row.supplier_bank_account || '',
        receiver_bank: row.supplier_bank_name || '',
        receiver_bank_code: '',
        receiver_remark: '',
        fileList: []
      }
      
      // 打印日志以便调试
      console.log('付款凭证表单数据:', this.voucherForm)
      console.log('原始行数据:', row)
      
      this.voucherDialogVisible = true
    },
    async submitVoucher() {
      try {
        await this.$refs.voucherForm.validate()
        this.voucherSubmitting = true
        
        // 构造请求参数，严格按照API文档格式
        const params = {
          id: '',  // 付款记录ID，新增时为空
          application_id: this.voucherForm.application_id,
          payment_type: this.voucherForm.payment_type,
          payment_amount: this.voucherForm.payment_amount,
          payment_time: this.voucherForm.payment_time,
          payment_image: '11111',  // 固定值
          payment_person: this.voucherForm.payment_person,
          pay_channel: this.voucherForm.pay_channel,
          pay_account: this.voucherForm.pay_account,
          pay_remark: this.voucherForm.pay_remark || '',
          receiver_method: this.voucherForm.receiver_method,
          receiver_channel: this.voucherForm.receiver_channel,
          receiver_name: this.voucherForm.receiver_name,
          receiver_account: this.voucherForm.receiver_account,
          receiver_bank: this.voucherForm.receiver_bank,
          receiver_bank_code: this.voucherForm.receiver_bank_code || '',
          receiver_remark: this.voucherForm.receiver_remark || '',
          fileList: this.voucherForm.fileList
        }

        // 打印请求参数，方便调试
        console.log('提交的参数:', params)

        const response = await request({
          url: '/api/v1/purchasing-order/payment/record/save',
          method: 'post',
          data: params
        })
        
        if (response.status === 1) {
          this.$message.success('保存成功')
          this.voucherDialogVisible = false
          this.getList() // 刷新列表
        } else {
          this.$message.error(response.msg || '保存失败')  // 使用msg字段
        }
      } finally {
        this.voucherSubmitting = false
      }
    },
    // 获取收款方式字典
    async getPaymentMethodDict() {
        try {
      const res = await request({
        url: '/api/v1/dict/type',
        method: 'post',
        data: {
          dictType: 'GYSSKFS',
          dictItemName: ''
        }
      })
      if (res.status === 1 && res.data) {
        this.paymentTypeOptions = res.data.map(item => ({
          value: item.itemValue,
          label: item.itemLabel
        }))
      }
    } catch (error) {
      console.error('获取收款类型失败:', error)
      this.$message.error('获取收款类型失败')
    }
    },
    // 获取收款渠道字典
    async getPaymentChannelDict() {
      try {
        const res = await request({
          url: '/api/v1/dict/type',
          method: 'post',
          data: {
            dictType: 'GYSSKQD',
            dictItemName: ''
          }
        })
        if (res.status === 1 && res.data) {
          this.paymentChannelOptions = res.data.map(item => ({
            value: item.itemValue,
            label: item.itemLabel
          }))
        }
      } catch (error) {
        console.error('获取收款渠道失败:', error)
        this.$message.error('获取收款渠道失败')
      }
    },
    // 获取付款类型字典
    async getPaymentTypeDict() {
      try {
        const res = await request({
          url: '/api/v1/dict/type',
          method: 'post',
          data: {
            dictType: 'FKLX',
            dictItemName: ''
          }
        })
        if (res.status === 1 && res.data) {
          this.paymentTypeList = res.data.map(item => ({
            value: item.itemValue,
            label: item.itemLabel
          }))
        }
      } catch (error) {
        console.error('获取付款类型失败:', error)
        this.$message.error('获取付款类型失败')
      }
    },
    // 获取付款渠道字典
    async getPayChannelDict() {
      try {
        const res = await request({
          url: '/api/v1/dict/type',
          method: 'post',
          data: {
            dictType: 'FKQD',
            dictItemName: ''
          }
        })
        if (res.status === 1 && res.data) {
          this.channels = res.data// 付款渠道  
          //这里只取一级渠道   
          this.payChannelOptions = res.data.filter(item => item.parentId === "0").map(item => ({
            value: item.itemValue,
            label: item.itemLabel
          }))

          
        }
      } catch (error) {
        console.error('获取付款渠道失败:', error)
        this.$message.error('获取付款渠道失败')
      }
    },
    // 获取付款账号字典
    getPayAccountDict() {
        //根据选择的付款渠道，获取对应的付款账号
        this.voucherForm.pay_account = ''
        const channel = this.channels.find(item => item.itemValue === this.voucherForm.pay_channel)
        this.payAccountOptions = this.channels.filter(item => item.parentId === channel.itemId).map(item => ({
          value: item.itemValue,
          label: item.itemLabel
        }))
    },
    // 上传前验证
    beforeUpload(file) {
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      
      if (!isJPGOrPNG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    // 上传成功回调
    handleUploadSuccess(response, file, fileList) {
      if (response.status === 1) {
        this.voucherForm.payment_image = response.data.SavePath
        this.$message.success('上传成功')
      } else {
        this.$message.error(response.msg || '上传失败')
        this.fileList = this.fileList.filter(f => f.uid !== file.uid)
      }
    },
    // 上传失败回调
    handleUploadError(err) {
      console.error('上传失败:', err)
      this.$message.error('上传失败')
    },
    // 超出限制回调
    handleExceed() {
      this.$message.warning('最多只能上传1张图片')
    },
    // 获取审批人状态类型
    getApproverStatusType(status) {
      const typeMap = {
        0: 'info',    // 未处理
        1: 'warning', // 处理中
        2: 'success', // 已通过
        3: 'danger'   // 已拒绝
      }
      return typeMap[status] || 'info'
    },
    formatDate(timestamp) {
      return moment(timestamp).format('YYYY-MM-DD HH:mm')
    },
     // 时间格式化函数
     formatDateTime(date) {
      if (!date) return '-'
      const d = new Date(date)
      if (isNaN(d.getTime())) return '-'
      
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')
      const second = String(d.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },

  }
}
</script>

<style lang="scss" scoped>
.app-container {
  padding: 20px;
  min-height: 100vh;
  background-color: #f0f2f5;

  .search-card,
  .table-card {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    position: relative;
    z-index: 1;
  }

  .pagination-container {
    padding: 20px 0;
    text-align: right;
  }
}

.flow-container {
  padding: 20px;

  .timeline-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    font-weight: bold;
    font-size: 14px;

    .step-status {
      color: #67C23A;
      font-size: 13px;
    }
  }

  .approver-list {
    .approver-row {
      margin-bottom: 12px;
      
      &:last-child {
        margin-bottom: 0;
      }

      .approver-info {
        display: flex;
        align-items: center;
        font-size: 13px;
        
        .approver-name {
          min-width: 80px;
        }

        .el-tag {
          margin: 0 8px;
          line-height: 20px;
          padding: 0 8px;
          font-size: 12px;
          min-width: 64px;
          text-align: center;

          &.pending {
            color: #f56c6c;
            border-color: #f56c6c;
            background-color: #fef0f0;
          }
        }

        .approve-comment {
          flex: 1;
          color: #606266;
          padding-left:1px;
          margin: 0 12px;
          border-left: 2px solid #EBEEF5;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .approve-time {
          color: #909399;
          font-size: 12px;
          white-space: nowrap;
          min-width: 135px;
        }
      }
    }
  }
}

::v-deep .el-timeline {
  .el-timeline-item {
    padding-bottom: 20px;

    &:last-child {
      padding-bottom: 0;
    }

    .el-timeline-item__node {
      &--large {
        width: 14px;
        height: 14px;
      }

      &.is-success {
        background-color: #67C23A;
      }

      &.is-warning {
        background-color: #E6A23C;
      }

      &.is-danger {
        background-color: #F56C6C;
      }
    }

    .el-timeline-item__wrapper {
      padding-left: 25px;
    }
  }
}

.flow-dialog {
  .flow-container {
    padding: 20px 10px;
  }

  ::v-deep .el-timeline {
    padding: 0 20px;

    .el-timeline-item {
      padding-bottom: 25px;

      &:last-child {
        padding-bottom: 0;
      }

      .el-timeline-item__node {
        &--large {
          width: 14px;
          height: 14px;
        }

        &.is-success {
          background-color: #67C23A;
        }

        &.is-warning {
          background-color: #E6A23C;
        }

        &.is-danger {
          background-color: #F56C6C;
        }
      }

      .el-timeline-item__wrapper {
        padding-left: 25px;
      }

      .el-timeline-item__timestamp {
        color: #909399;
        font-size: 13px;
        margin-bottom: 8px;
      }
    }
  }

  .flow-item {
    background: #f8f9fa;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 10px;

    .flow-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      .flow-title {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 500;

        .step-tag {
          background: #ecf5ff;
          color: #409eff;
          padding: 2px 6px;
          border-radius: 4px;
          margin-right: 8px;
          font-size: 12px;
        }
      }
    }

    .flow-content {
      .flow-info {
        .info-header {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          color: #606266;

          i {
            margin-right: 5px;
          }
        }

        .approver-list {
          .approver-item {
            padding: 10px 0;
            border-bottom: 1px dashed #ebeef5;

            &:last-child {
              border-bottom: none;
            }

            .approver-info {
              display: flex;
              flex-direction: column;
              gap: 8px;
            }

            .approver-row {
              display: flex;
              align-items: center;
              gap: 12px;
            }

            .approve-comment {
              color: #606266;
              font-size: 13px;
              padding-left: 2px;
            }
          }
        }

        .no-approver {
          color: #909399;
          font-size: 13px;
        }
      }
    }
  }
}

.form-section-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #EBEEF5;
}

.el-form {
  padding: 0 20px;
  
  .el-form-item {
    margin-bottom: 18px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.el-input-number {
  width: 100%;
}

.el-textarea {
  textarea {
    min-height: 80px;
  }
}
</style>